import global from '../global'

const brochureList = global.serverUrl + '/backstage/brochure/list'
const brochureGet = global.serverUrl + '/backstage/brochure/get'
export default {
  brochureList,
  brochureGet
}



// WEBPACK FOOTER //
// ./src/config/api/brochure.js